module.exports = __webpack_public_path__ + "static/media/marketing_use_case_4.0cc9a072.svg";